module.exports = __webpack_public_path__ + "img/layout.4516063a.svg";